import React from 'react';

// Mobx
import { inject, observer } from 'mobx-react';

// FlatList
import DataTable from 'react-data-table-component';

// Router
import { Link } from 'react-router-dom';

// Navigation
import { useNavigate, Navigate } from 'react-router-dom';

// Helpers
import Helpers from '../../helpers';

// Css
import '../../assets/css/app.css';

// Layout
import CommerceLayout from '../layouts/CommerceLayout';

// Components
import FunctionalButton from '../../components/Buttons/FunctionalButton';

@inject('AuthStore', 'TrainingStore')
@observer
class Trainings extends React.Component<any> {
    constructor(props: any) {
        super(props);
    }

    componentDidMount(): void {
    }

    render() {
        const storeId: any = localStorage.getItem('storeId');

        return (
            this.props.AuthStore.userData.isLogin ?
                storeId !== null ?
                    <CommerceLayout
                        title={Helpers.translation('trainings')}
                        visibleCategories={false}
                    >
                        <section id="shop">
                            <div className="container mx-auto p-4">
                                <div className="flex flex-col">
                                    <div className="w-full mt-4">
                                        <DataTable
                                            columns={[
                                                {
                                                    name: Helpers.translation('title'),
                                                    selector: (row: any) => row.title,
                                                },
                                                {
                                                    name: Helpers.translation('transactions'),
                                                    selector: (row: any) => {
                                                        return (
                                                            <div className="grid grid-cols-2 gap-1">
                                                                <Link to={`/trainings/${row.id}`}>
                                                                    <FunctionalButton
                                                                        text={Helpers.translation('view')}
                                                                        rounded
                                                                        customClasses="text-xs"
                                                                    />
                                                                </Link>
                                                            </div>
                                                        )
                                                    },
                                                },
                                            ]}
                                            data={Helpers.objectToArray(this.props.TrainingStore.trainings).filter((training: any) => {
                                                const storeId: any = localStorage.getItem('storeId');
                                                const storeIndex = Helpers.findIndexByCriteria(training.stores, "id", parseInt(storeId));

                                                return training.stores.length < 1 || storeIndex !== -1;
                                            })}
                                        />
                                    </div>
                                </div>
                            </div>
                        </section>
                    </CommerceLayout>
                    :
                    <Navigate to="/" replace={true} />
                :
                <Navigate to="/login" replace={true} />
        )
    }
}

function WithNavigate(props: any) {
    let navigate = useNavigate();
    return <Trainings {...props} navigate={navigate} />
}

export default WithNavigate;